import { wikiErrorMessage } from "./display-labels.js";

/** 仅适配独立百科客户端的用户反馈；不改成功数据、HTTP 状态、业务码或原错误对象。 */
export function installWikiErrorLocalization(client, getLocale) {
  return client.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error?.__CANCEL__ || error?.code === "ERR_CANCELED")
        return Promise.reject(error);
      const message = wikiErrorMessage(error, getLocale());
      const localized = Object.assign(new Error(message), error);
      localized.message = message;
      if (error?.isAxiosError) localized.isAxiosError = true;
      if (error?.response) {
        const original = error.response.data;
        const detail = original?.detail;
        // 结构化错误保留嵌套 code、字段位置和验证数据；只改其显示消息。
        const displayDetail = Array.isArray(detail)
          ? detail
          : detail && typeof detail === "object"
            ? { ...detail, message }
            : message;
        localized.response = {
          ...error.response,
          data:
            original && typeof original === "object" && !Array.isArray(original)
              ? { ...original, detail: displayDetail, uiMessage: message }
              : { detail: message },
        };
      }
      return Promise.reject(localized);
    },
  );
}
